import { Close } from '@mui/icons-material';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  SxProps,
} from '@mui/material';
import { abyssColors } from '@/theme/colors';
import { CSSProperties } from 'styled-components';

type GenericDialogProps = {
  open: boolean;
  onClose: () => void;
  title?: string;
  content: React.ReactNode;
  actions?: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  minWidth?: string;
  dialogStyles?: SxProps;
  titleStyles?: SxProps;
  contentStyles?: SxProps;
  actionsStyles?: SxProps;
  paperStyles?: SxProps;
  closeIconStyles?: SxProps;
  showCloseIcon?: boolean;
  id?: string;
};

export const GenericDialog = ({
  open,
  onClose,
  title,
  content,
  actions,
  maxWidth = 'sm',
  minWidth = '45rem',
  dialogStyles = {},
  titleStyles = {},
  contentStyles = {},
  actionsStyles = {},
  paperStyles = {},
  closeIconStyles = {},
  showCloseIcon = false,
  id,
}: GenericDialogProps) => {
  const dialogBorderRadius = (dialogStyles as CSSProperties).borderRadius;
  return (
    <Dialog
      id={id}
      open={open}
      onClose={(event: React.SyntheticEvent) => {
        if (event) {
          event.stopPropagation();
        }
        onClose();
      }}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{
        sx: paperStyles,
        onClick: (event: React.MouseEvent) => {
          event.stopPropagation();
        },
      }}
      slotProps={{
        backdrop: {
          sx: { backgroundColor: 'rgba(0, 0, 0, 0.8)' },
          onClick: (event: React.MouseEvent) => {
            event.stopPropagation();
          },
        },
      }}
      sx={{
        ...dialogStyles,
        '& .MuiPaper-root': {
          minWidth,
          ...(dialogBorderRadius ? { borderRadius: dialogBorderRadius } : {}),
        },
      }}
    >
      {title && (
        <DialogTitle
          sx={{
            ...titleStyles,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <span>{title}</span>
          {showCloseIcon && (
            <IconButton
              disableRipple
              sx={{ padding: 0 }}
              onClick={(event: React.MouseEvent) => {
                event.stopPropagation();
                onClose();
              }}
            >
              <Close
                sx={{ color: abyssColors.primary[300], fontSize: '2rem', ...closeIconStyles }}
              />
            </IconButton>
          )}
        </DialogTitle>
      )}
      <DialogContent sx={contentStyles}>{content}</DialogContent>
      {actions && <DialogActions sx={actionsStyles}>{actions}</DialogActions>}
    </Dialog>
  );
};
